module.exports = __webpack_public_path__ + "static/img/zt5.a7bfee7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main/zt5.png
// module id = 311
// module chunks = 34